// статусы section
export const COLLECTED = 'collected';
export const AVAILABLE = 'available';
export const COMPLETED = 'completed';

// статусы subQuests
export const ACTIVE = 'active';
export const INACTIVE = 'inactive';
